import { Card, BlockStack, InlineStack, Text, Button } from '@shopify/polaris';
import { XIcon } from '@shopify/polaris-icons';
import ChatRow from './ChatRow';
import TypingDots from './TypingDots';
import { StyledChatThread } from './styled';

const MESSAGES: Array<{ role: 'user' | 'claude'; text: string }> = [
  { role: 'user', text: "Where's order #1284?" },
  { role: 'claude', text: 'Order #1284 was delivered 2 hours ago by FedEx. Maya Patel signed for it at 11:42 AM.' },
  { role: 'user', text: 'Which carrier is late this week?' },
  { role: 'claude', text: 'DHL has the worst on-time rate this week (76%). UPS leads at 96%, FedEx at 94%.' },
  { role: 'user', text: 'Draft a delay notice for #5678.' },
];

interface IProps {
  onDismiss: () => void;
}

const AskAiAssistantCard = ({ onDismiss }: IProps) => (
  <Card>
    <BlockStack gap="300">
      <InlineStack align="space-between" blockAlign="start">
        <BlockStack gap="050">
          <Text as="h3" variant="headingMd">Ask your AI assistant about any shipment</Text>
          <Text as="p" tone="subdued">From the chat your team already uses.</Text>
        </BlockStack>
        <Button
          variant="tertiary"
          icon={XIcon}
          accessibilityLabel="Hide examples"
          onClick={onDismiss}
        />
      </InlineStack>
      <StyledChatThread>
        {MESSAGES.map((m, i) => <ChatRow key={`${m.role}-${i}`} role={m.role} text={m.text} />)}
        <TypingDots />
      </StyledChatThread>
    </BlockStack>
  </Card>
);

export default AskAiAssistantCard;
